import { css } from 'styled-components';

import variables from '../settings/variables';
import colors from '../settings/colors';

export default css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${colors.colorHeadings};
    display: block;
    font-family: ${variables.headingsFontFamily};
    font-weight: ${variables.headingsFontWeight};
    line-height: ${variables.headingsLineHeight};
    margin-top: 0;
    text-rendering: optimizeLegibility;
  }

  h1,
  h2,
  h3 {
    margin-bottom: ${variables.baseSpacingUnit};
  }

  h4,
  h5,
  h6 {
    margin-bottom: ${variables.halfSpacingUnit};
  }

  h1 {
    font-size: ${variables.fontSizeH1};
  }

  h2 {
    font-size: ${variables.fontSizeH2};
  }

  h3 {
    font-size: ${variables.fontSizeH3};
  }

  h4 {
    font-size: ${variables.fontSizeH4};
  }

  h5 {
    font-size: ${variables.fontSizeH5};
  }

  h6 {
    font-size: ${variables.fontSizeH6};
  }

  p {
    margin: 0 0 ${variables.baseSpacingUnit};
    color: ${colors.textSecondary};
    font-weight: 500;
    line-height: 1.7;
  }
`;
